export default __webpack_public_path__ + "alberta-mobile.783525f545c2e2a0986f.svg";